<svg width="293" height="293" viewBox="0 0 293 293" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3_2)">
<g clip-path="url(#clip1_3_2)">
<path d="M146.21 36.23C175.65 36.23 203.32 47.69 224.14 68.51C244.96 89.33 256.42 117 256.42 146.44C256.42 175.88 244.96 203.55 224.14 224.37C203.32 245.19 175.65 256.65 146.21 256.65C116.77 256.65 89.1 245.19 68.28 224.37C47.46 203.55 36 175.88 36 146.44C36 117 47.46 89.33 68.28 68.51C89.1 47.69 116.77 36.23 146.21 36.23ZM146.21 0.22998C65.46 0.22998 0 65.69 0 146.44C0 227.19 65.46 292.65 146.21 292.65C226.96 292.65 292.42 227.19 292.42 146.44C292.42 65.69 226.96 0.22998 146.21 0.22998Z" fill="#233857"/>
<path d="M180.3 114.48L146.21 63.78L112.12 114.48L61.42 148.57L112.12 182.66L146.21 233.36L180.3 182.66L231 148.57L180.3 114.48ZM146.21 175.58C131.21 175.58 119.21 163.58 119.21 148.58C119.21 133.58 131.21 121.58 146.21 121.58C161.21 121.58 173.21 133.58 173.21 148.58C173.21 163.58 161.21 175.58 146.21 175.58Z" fill="#D02C2F"/>
</g>
</g>
<defs>
<clipPath id="clip0_3_2">
<rect width="293" height="293" fill="white"/>
</clipPath>
<clipPath id="clip1_3_2">
<rect width="293" height="293" fill="white"/>
</clipPath>
</defs>
</svg>
